import { useMutation } from "@apollo/client";
import { gql } from "@src/__generated__";

const CREATE_COMPANY_TOKEN = gql(`
  mutation CreateCompanyToken($companyId: String!) {
    createCompanyToken(companyId: $companyId)
  }
`);

export function useCreateCompanyToken() {
  const [createCompanyToken] = useMutation(CREATE_COMPANY_TOKEN);
  return { createCompanyToken };
}
